<template>
  <div class="app-container">
    <h1 class="app-tit">사업자 정보</h1>
    <div class="marker-txt-wrap">
      <div class="txt-group">
        <h2>대표자</h2>
        <p>공정일</p>
      </div>
      <div class="txt-group">
        <h2>E-mail</h2>
        <p>connect@sconai.com</p>
      </div>
      <div class="txt-group">
        <h2>통신판매신고</h2>
        <p>통신판매신고 제2025-인천부평-1947호</p>
      </div>
      <div class="txt-group">
        <h2>주소</h2>
        <p>
          본점 : 인천광역시 부평구 충선로 209번길 41 <br />
          서울지사: 서울특별시 영등포구 영등포로 150
        </p>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts"></script>

<style scoped lang="scss">
.app-container {
  padding: 0 0 4rem;
}

.head-txt-wrap {
  padding: 1rem 0;
  strong {
    font-size: $font-size-psmall;
    font-weight: 500;
    display: block;
    margin-bottom: $size-xs;
  }
  p {
    font-size: $font-size-psmall;
    color: $color-gray-500;
  }
}
.marker-txt-wrap {
  .marker-dot {
    .non-marker {
      padding-left: 0;
      margin-bottom: $size-s;
      &::before {
        display: none;
      }
    }
    h3 {
      display: block;
      font-size: $font-size-psmall;
      font-weight: 600;
      padding-bottom: $size-s;
    }
    .inr {
      padding-bottom: $size-s;
      &.mk-hp-wrap {
        padding-left: $size-m;
        h4 {
          font-size: $font-size-psmall;
          font-weight: 600;

          padding-bottom: $size-xs;
        }
      }
      p {
        font-size: $font-size-psmall;
      }
    }
  }
  .last-txt {
    padding: 1rem 0;
    font-size: $font-size-psmall;
  }
}
</style>
